export const AMERICA_ID = 5
export const INDIA_ID = 1
